import { toast } from 'react-hot-toast';

// Ref. documentation: https://react-hot-toast.com/
export const useToast = () => {
    const toastSuccess = (text: string) => {
        toast.success(text);
    };
    const toastError = (text: string) => {
        toast.error(text);
    };

    const toastInfo = (text: string) => {
        toast(text, { icon: 'ℹ️', duration: 6000 });
    };
    const toastWarning = (text: string) => {
        toast(text, { icon: '⚠️', duration: 10000, style: { whiteSpace: 'pre-line' } });
    };
    const toastLoading = (text: string) => toast.loading(text);
    const dismissToast = (toastId: string) => toast.dismiss(toastId);

    const toastLoader = (loadingText: string, successText: string, promise: any) => {
        toast.promise(
            promise,
            {
                loading: loadingText,
                success: successText,
                error: 'Something went wrong, please try again.',
            },
            {
                style: {
                    borderRadius: '10px',
                    background: '#333',
                    color: '#fff',
                },
                success: {
                    duration: 6000,
                },
            },
        );
    };
    return { toastSuccess, toastError, toastInfo, toastWarning, toastLoading, dismissToast, toastLoader };
};
